import { Container, SytelyStteper } from "./styles";
import imag_login from "../../assets/undraw_good_doggy_re_eet7.svg";
import logo_nina from "../../assets/logo_rosa_nina.png";
import {
  Input,
  InputGroup,
  InputLeftAddon,
  Text,
  FormControl,
  useToast,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalFooter,
  ModalHeader,
  useDisclosure,
  useSteps,
  Stepper,
  Step,
  StepIndicator,
  StepIcon,
  StepNumber,
  StepStatus,
  Box,
  StepTitle,
  StepDescription,
  StepSeparator,
} from "@chakra-ui/react";
import { User, Lock, UserPlus } from "@phosphor-icons/react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { AxiosError } from "axios";
import { api } from "../../Api/ApiService";
import React, { useContext, useEffect, useState } from "react";
import { AppConText } from "../../context/ContexProvaider";

interface ILogin {
  email: string;
  senha: string;
}

const Login: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigator = useNavigate();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");

  const [codigo, setCodigo] = useState(0);
  const [inputCodigo, setInputCodigo] = useState(0);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ILogin>();

  const {
    register: registerNewPassword,
    handleSubmit: handleSubmitNewPassword,
    formState: { errors: errorsPass },
    reset: resetForm,
  } = useForm<ILogin>();

  const { login } = useContext(AppConText);

  async function onSubmit(data: ILogin) {
    setIsLoading(true);
    await login(data.email, data.senha);
    setIsLoading(false);
  }

  async function onSubmitResetPassword(data: ILogin) {
    try {
      if (senha.length < 6) {
        toast({
          title: "Atenção",
          description: "A senha precisa ter no mínimo 6 caracteres",
          status: "warning",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      } else {
        if (senha === confirmaSenha) {
          const result = await api.patch(
            `/users/redefine_password?token=${process.env.REACT_APP_TOKEN_API}`,
            {
              new_pass: senha,
            },
            {
              params: {
                email: email,
              },
            }
          );

          toast({
            title: "Senha redefinida",
            description: "Senha redefinida com sucesso",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
          resetForm();
          onClose();
        } else {
          toast({
            title: "Atenção",
            description: "As senhas não não iguais, tente novamente",
            status: "warning",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
        }
      }
    } catch (error: AxiosError | any) {
      console.log(error);
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  const steps = [
    { title: "Email", description: "Informe seu email" },
    {
      title: "Código de verificação",
      description: "Digite o código enviado para o seu email",
    },
    { title: "Redefinir", description: "Digite sua nova senha" },
  ];

  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });

  async function sendVerificationCod() {
    try {
      const res = await api.post(
        `/email_verificacao?token=${process.env.REACT_APP_TOKEN_API}`,
        {
          email: email,
        }
      );
      setCodigo(res.data.data);
      setActiveStep(activeStep + 1);
    } catch (error: AxiosError | any) {
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  function validationCod() {
    if (codigo == inputCodigo) {
      setActiveStep(activeStep + 1);
    } else {
      toast({
        title: "Erro",
        description: "Código inválido",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }
  return (
    <Container>
      <div className="login">
        <div className="right">
          <h1>Seja bem-vindo a plataforma Nina</h1>
          <div className="imag">
            <img src={imag_login} />
          </div>
        </div>

        <div className="left">
          <div className="imag">
            <img src={logo_nina} />
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <InputGroup size={"sm"}>
              <InputLeftAddon bg={"#FFFFFF"} p={2}>
                <User size={20} />
              </InputLeftAddon>
              <Input
                type="text"
                className="email"
                bg={"#E2E2F0"}
                placeholder="Digite o seu E-mail"
                {...register("email", {
                  required: "Campo obrigatório",
                })}
              />
            </InputGroup>
            {errors.email && (
              <span className="label-erro">{errors.email.message}</span>
            )}

            <InputGroup size={"sm"} mt={5}>
              <InputLeftAddon bg={"#FFFFFF"} p={2}>
                <Lock size={20} />
              </InputLeftAddon>
              <Input
                type="password"
                className="email"
                bg={"#E2E2F0"}
                placeholder="Digite a sua senha"
                {...register("senha", {
                  required: "Campo obrigatório",
                })}
              />
            </InputGroup>
            {errors.senha && (
              <span className="label-erro">{errors.senha.message}</span>
            )}

            <button className="btn_entrar">Entrar</button>

            <Link to={""} className="link_esq_senha" onClick={() => onOpen()}>
              Esqueci a senha
            </Link>

            <Link className="btn_cadastro" to={"/cadastroUser"}>
              <UserPlus className="icon" size={20} />
              Cadastre-se
            </Link>
          </form>
        </div>
      </div>

      <div className="footer">
        <footer>
          <p>Instituto Leão Sampaio de Ensino Universitário &copy; 2023</p>
        </footer>
      </div>

      <form>
        <Modal isOpen={isOpen} onClose={onClose} size={"5xl"}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader
              display={"flex"}
              justifyContent={"center"}
              flexDir={"column"}
              gap={5}
            >
              <Box display={"flex"} justifyContent={"center"}>
                <Text color={"#3F3D56"} fontWeight={"bold"} fontSize={25}>
                  Redefinição de senha
                </Text>
              </Box>
              <SytelyStteper index={activeStep} padding={3}>
                {steps.map((step, index) => (
                  <Step key={index}>
                    <StepIndicator>
                      <StepStatus
                        complete={<StepIcon />}
                        incomplete={<StepNumber />}
                        active={<StepNumber />}
                      />
                    </StepIndicator>
                    <Box>
                      <StepTitle>{step.title}</StepTitle>
                    </Box>
                    <StepSeparator />
                  </Step>
                ))}
              </SytelyStteper>
            </ModalHeader>

            <ModalBody display={"flex"} flexDir={"column"} gap={5}>
              {activeStep == 0 ? (
                <>
                  <FormControl display={"flex"} flexDir={"column"}>
                    <Text>Digite seu endereço de email:</Text>
                    <Input
                      type="email"
                      h={8}
                      border={"0.125rem solid #B0BEC5"}
                      isRequired
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormControl>
                </>
              ) : (
                <>
                  {activeStep == 1 ? (
                    <>
                      <FormControl display={"flex"} flexDir={"column"}>
                        <Text>Digite o código enviado para o seu email:</Text>
                        <Input
                          type="number"
                          h={8}
                          border={"0.125rem solid #B0BEC5"}
                          isRequired
                          onChange={(e) =>
                            setInputCodigo(Number(e.target.value))
                          }
                        />
                      </FormControl>
                    </>
                  ) : (
                    <>
                      <FormControl display={"flex"} flexDir={"column"}>
                        <Text>Nova senha:</Text>
                        <Input
                          type={"password"}
                          h={8}
                          border={"0.125rem solid #B0BEC5"}
                          onChange={(e) => setSenha(e.target.value)}
                        ></Input>
                      </FormControl>

                      <FormControl display={"flex"} flexDir={"column"}>
                        <Text>Confirmar senha:</Text>
                        <Input
                          type={"password"}
                          h={8}
                          border={"0.125rem solid #B0BEC5"}
                          onChange={(e) => setConfirmaSenha(e.target.value)}
                        ></Input>
                      </FormControl>
                    </>
                  )}
                </>
              )}
            </ModalBody>

            <ModalFooter marginTop={3} marginBottom={3}>
              <InputGroup gap={8} display={"contents"}>
                <Button
                  w={40}
                  h={8}
                  border={"1px solid #c03333"}
                  color={"#c03333"}
                  fontWeight={"medium"}
                  marginRight={"5"}
                  backgroundColor={"white"}
                  onClick={() => {
                    onClose();
                  }}
                >
                  Cancelar
                </Button>

                {activeStep == 0 ? (
                  <>
                    <Button
                      type="submit"
                      w={40}
                      h={8}
                      border={"1px solid #044549"}
                      color={"#044549"}
                      fontWeight={"medium"}
                      backgroundColor={"white"}
                      onClick={() => {
                        sendVerificationCod();
                      }}
                    >
                      Próximo
                    </Button>
                  </>
                ) : (
                  <>
                    {activeStep == 1 ? (
                      <>
                        <Button
                          type="submit"
                          w={40}
                          h={8}
                          border={"1px solid #044549"}
                          color={"#044549"}
                          fontWeight={"medium"}
                          backgroundColor={"white"}
                          onClick={() => {
                            validationCod();
                          }}
                        >
                          Próximo
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          type="submit"
                          w={40}
                          h={8}
                          border={"1px solid #044549"}
                          color={"#044549"}
                          fontWeight={"medium"}
                          backgroundColor={"white"}
                          onClick={handleSubmitNewPassword(
                            onSubmitResetPassword
                          )}
                        >
                          Redefinir senha
                        </Button>
                      </>
                    )}
                  </>
                )}
              </InputGroup>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </form>
    </Container>
  );
};

export { Login };
